import React, { useCallback, useEffect, useMemo, useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link'

import cName from "classnames";
import styles from './index.module.scss';

import Wrapper from '@/components/wrapper';
import Pagination from '@/components/seo-pagination';

import request from '@/utils/request';
import { getServerSideProps as _getServerSideProps, getHead } from '@/utils/useHead';

import { useTranslations } from "next-intl";
import { useRouter } from "next/router";


interface IProps {

}
export async function getServerSideProps(context: any) {
  const res: any = await _getServerSideProps(context);
  const { data } = await request.get(`/api/get_news_list`, {
    params: {
      lang: context.locale || context.defaultLocale || 'cn',
      category_id: 1,
      page: context.query.page || 1,
      rows: 12,
    }
  })
  return {
    props: {
      ...res.props,
      data: data?.data || null,
    }
  }
}

const Photo: NextPage<IProps> = ({ menuDetail, data }: any) => {
  const router = useRouter();
  const t = useTranslations("media.news");

  return (
    <div>
      <Wrapper>
        <div className={cName(styles.container, 'm-1600')}>
          {getHead(menuDetail)}
          <h2>{t('title')}</h2>
          <div className={styles.newsList}>
            {
              data?.list?.map((item: any) => (
                <Link key={item?.id} href={item?.info?.outlink || `/media/news/news_detail/${item?.id}`}>
                  <a target={item?.info?.outlink ? "_blank" : ''}>
                    <div className={styles.newItem}>
                      <img src={item?.info?.image} alt="" />
                      <div>
                        <h3>{item?.info?.title}</h3>
                        <p>{item?.info?.brief}</p>
                        <span>{new Date(item?.publish_time * 1000).toLocaleString().replace(/\//g, '-').split(' ')[0]}</span>
                        <img className={styles.btn} src="/image/news-bg-btn.png" alt="" />
                      </div>
                    </div>
                  </a>
                </Link>
              ))
            }
          </div>
          <Pagination
            page={Number(router.query.page || 1)}
            total={data?.total}
            size={data?.list_rows}
          />
        </div>
      </Wrapper>
    </div>
  );
};

export default Photo;
